import {
  confirmRefundOffer,
  deleteRefundOffer,
  getManageFlowBookingById,
  getManageFlowBookingByNumberAndEmail,
  getManageFlowTravelAccountsMap,
  initiateLegsRefund,
  initiateNonTripOffersRefund,
  sendTicketsToEmail,
} from '@/features/manage/manageActions';
import {
  getProfileActiveTickets,
  getProfileActiveTravelPasses,
  getProfileActiveVouchers,
  getProfileHistoryTickets,
  getProfileHistoryTravelPasses,
  getProfileHistoryVouchers,
  updateProfile,
} from '@/features/profile/profileActions';
import {
  addPurchaseFlowBookingAncillaries,
  createPurchaseFlowNonTripOfferBooking,
  createPurchaseFlowTripOfferBooking,
  deletePurchaseFlowBooking,
  getInboundJourneys,
  getNonTripOffers,
  getOutboundJourneys,
  getPurchaseFlowBookingAdditionalOffersSearch,
  getPurchaseFlowBookingById,
  getPurchaseFlowTravelAccountsMap,
  initiateAdyenPayment,
  initiateExternalPayment,
  initiateZeroPayment,
  updateBookingPassengers,
  updatePurchaseFlowBookingPurchaser,
} from '@/features/purchase/purchaseActions';
import {
  resetPassword,
  sendPasswordResetLink,
} from '@/features/reset-password/resetPasswordActions';
import { createLoadingSelector } from '@/store/utils';

export const purchaseFlowBookingFetchingLoadingSelector = createLoadingSelector(
  getPurchaseFlowBookingById
);

export const outboundOrInboundJourneysLoadingSelector = createLoadingSelector(
  getOutboundJourneys,
  getInboundJourneys
);

export const nonTripOffersLoadingSelector =
  createLoadingSelector(getNonTripOffers);

export const purchaseFlowBookingCreationLoadingSelector = createLoadingSelector(
  createPurchaseFlowTripOfferBooking,
  createPurchaseFlowNonTripOfferBooking,
  getPurchaseFlowBookingById
);

export const addAncillaryLoadingSelector = createLoadingSelector(
  addPurchaseFlowBookingAncillaries
);

export const checkoutLoadingSelector = createLoadingSelector(
  getPurchaseFlowBookingById,
  getPurchaseFlowBookingAdditionalOffersSearch,
  getPurchaseFlowTravelAccountsMap
);

export const manageBookingSearchLoadingSelector = createLoadingSelector(
  getManageFlowBookingByNumberAndEmail,
  getManageFlowTravelAccountsMap
);

export const manageBookingRefundLoadingSelector = createLoadingSelector(
  initiateLegsRefund,
  initiateNonTripOffersRefund,
  deleteRefundOffer,
  confirmRefundOffer,
  getManageFlowBookingById
);

export const sendTicketsToEmailLoadingSelector =
  createLoadingSelector(sendTicketsToEmail);

export const sendPasswordResetLinkLoadingSelector = createLoadingSelector(
  sendPasswordResetLink
);

export const resetPasswordLoadingSelector =
  createLoadingSelector(resetPassword);

export const initiatePaymentLoadingSelector = createLoadingSelector(
  updateBookingPassengers,
  updatePurchaseFlowBookingPurchaser,
  initiateAdyenPayment,
  initiateExternalPayment,
  initiateZeroPayment
);

export const profileBookingSearchLoadingSelector = createLoadingSelector(
  getManageFlowBookingByNumberAndEmail,
  getManageFlowTravelAccountsMap,
  getProfileActiveTickets,
  getProfileHistoryTickets,
  getProfileActiveTravelPasses,
  getProfileHistoryTravelPasses,
  getProfileActiveVouchers,
  getProfileHistoryVouchers
);

export const updateProfileLoadingSelector =
  createLoadingSelector(updateProfile);

export const updatePassengersLoadingSelector = createLoadingSelector(
  updateBookingPassengers
);

export const cancelBookingLoadingSelector = createLoadingSelector(
  deletePurchaseFlowBooking
);
